export default {
    positionStackedChart: {
        forecastBaseline: 'Osnovna prognoza',
        thisContract: 'Ovaj ugovor',
        otherFutures: 'Ostali futures',
        finalPosition: 'Konačna pozicija',
        ariaLabel:
            'Grafikon složene pozicije: osnovna prognoza, ovaj ugovor, ostali futures i linija konačne pozicije',
        tableBucket: 'Interval',
        tableForecast: 'Prognoza',
        tableFinal: 'Konačno',
    },
}
